"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Skeleton = _interopRequireDefault(require("./Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyle = (0, _makeStyles.default)({
  container: function container(_ref) {
    var width = _ref.width,
        margin = _ref.margin;
    return {
      display: 'flex',
      flexDirection: 'column',
      width: width,
      margin: margin
    };
  },
  rectSkeleton: {
    margin: '24px 0'
  },
  textSkeleton: {
    margin: '8px 0'
  }
});

var LoadingPlaceholder = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      width = _ref2.width,
      margin = _ref2.margin;

  var _useStyle = useStyle({
    width: width,
    margin: margin
  }),
      container = _useStyle.container,
      textSkeleton = _useStyle.textSkeleton,
      rectSkeleton = _useStyle.rectSkeleton;

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "".concat(container, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "text",
    width: "48%",
    height: "24px"
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rectangular",
    width: "100%",
    height: "120px",
    className: rectSkeleton
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "text",
    width: "100%",
    height: "24px"
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "text",
    width: "100%",
    height: "24px",
    className: textSkeleton
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "text",
    width: "100%",
    height: "24px"
  }));
});

var _default = LoadingPlaceholder;
exports.default = _default;